/** @return {object} - get info of wizard */
const getWizardInfoRequired = state => {
  return state.wizard.required.infos;
};
/** @return {object} - get info of wizard */
const getWizardInfoPostalCode = state => {
  return state.wizard.required.infos.postalcode;
};

/** @return {object} - get optional info of wizard */
const getWizardInfoOptional = state => {
  return state.wizard.optional.infos;
};

/** @return {object} - get info of wizard */
const getWizardPercentFill = state => {
  return state.wizard.fillPercent;
};

/** @return {object} - get info of wizard */
const getWizardPercentFillLast = state => {
  return state.wizard.fillPercentLast;
};

/** @return {boolean} - get info of wizard 3rd step */
const getWizardStrapiFormId = state => {
  return state.wizard.strapiFormId;
};

/** @return {object} - get strapi form of wizard */
const getWizardStrapiForm = state => {
  return state.wizard.form;
};

/** @return {array} - get strapi form answers */
const getWizardFormAnswers = state => {
  return state.wizard.answers;
};

export default {
  getWizardInfoRequired,
  getWizardPercentFill,
  getWizardPercentFillLast,
  getWizardInfoOptional,
  getWizardInfoPostalCode,
  getWizardStrapiFormId,
  getWizardStrapiForm,
  getWizardFormAnswers,
};
